<template>
  <span
    style="cursor: pointer"
    v-if="despieceArt != ''"
    @click="DownloadDespiece()"
  >
   <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
           <v-avatar 
      v-bind="attrs"
          v-on="on"
          size="30" class="ml-2" color="red darken-4">
      <v-icon class="ml-0" dark size="25"> mdi-file-pdf-box </v-icon>
    </v-avatar>
      </template>
      <span>Descargar Despiece</span>
    </v-tooltip>
 
  </span>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    codArt: String,
    despieceArt: String,
    despieceFile: String,
  },
  computed: {
    ...mapState(["despieCes"]),
  },
  methods: {
    DownloadDespiece() {
      const uri = `${this.despieCes}${this.despieceFile}`;

      const link = document.createElement("a");
      link.href = uri;
      link.setAttribute("target", "_blank");
      link.setAttribute("download", "download");
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>

<style>
</style>